export const saudacao = () => {
     const userData = JSON.parse(localStorage.getItem('userData') || '{}');
     
     if (userData?.genero === 'Masculino') {
          return 'Bem-vindo';
     } else if (userData?.genero === 'Feminino') {
          return 'Bem-vinda';
     } else {
          return 'Bem vindo(a)';
     }
};